import { updateSolutions, withLoginUser } from 'src/api/user'
import { SolutionsForm } from './SolutionsForm'

export const SolutionsEditor = withLoginUser(({ user }) => (
  <SolutionsForm user={user} submit={updateSolutions} />
))
